const fieldTypes = {
  TEXT_FIELD: { id: 1 },
  TEXT_AREA: { id: 2 },
  CHECKBOX: { id: 3 },
  CUSTOM_LIST: { id: 5 },
  ATTACHMENT: { id: 6 },
  HEADER: { id: 7 },
  CHECKBOX_GROUP: { id: 8 },
  RADIO_BUTTON: { id: 9 },
  LOOP: { id: 10 },
  ASSET: { id: 11 },
  ACTION: { id: 12 },
};

const blockTypes = [
  fieldTypes.CUSTOM_LIST.id,
  fieldTypes.TEXT_AREA.id,
  fieldTypes.HEADER.id,
  fieldTypes.LOOP.id,
  fieldTypes.CHECKBOX_GROUP.id,
  fieldTypes.ATTACHMENT.id,
  fieldTypes.ACTION.id,
];

const hideLabelComponents = [fieldTypes.CHECKBOX.id];
const nonInputElement = [fieldTypes.HEADER.id];

export { fieldTypes, blockTypes, hideLabelComponents, nonInputElement };
